import { ConnectionUtils } from "@inter-ikea-core/core";
import CalculateCrossBraceComponent from "../components/CalculateCrossBraceComponent";
import RemovedCrossBraceComponent from "../components/RemovedCrossBraceComponent";
import { CROSS_BRACE } from "../constants";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
import { getEntityProductRef } from "../utils/entityUtils";
import { getFirstAttachmentBasedOnEntity } from "./attachedTo";
import { replaceProductPart } from "./productUtils";
import { selectChildEntityByPartKey } from "./sideUnitHandler";
export const calculateCrossbrace = (_entity) => {
    const mostLeftEntity = getFirstAttachmentBasedOnEntity(_entity);
    const entity = mostLeftEntity ? mostLeftEntity : _entity;
    addCalculateCrossBraceComponent(entity);
};
export const addCalculateCrossBraceComponent = (_entity) => _entity.addComponent(new CalculateCrossBraceComponent(_entity));
export const detachCrossBrace = (_entity) => {
    const crossBraceEntity = selectChildEntityByPartKey(_entity, CROSS_BRACE);
    if (!crossBraceEntity)
        return;
    const crossBraceProductRef = getEntityProductRef(crossBraceEntity);
    _entity.addComponent(new RemovedCrossBraceComponent(crossBraceProductRef));
    ConnectionUtils.disconnectAndDisposeEntityAndHierarchy(crossBraceEntity);
};
export const attachCrossBrace = (_entity, _coreServices) => {
    var _a;
    const crossBraceRef = (_a = _entity.getComponent(COMPONENT_IDS.REMOVED_CROSS_BRACE)) === null || _a === void 0 ? void 0 : _a.crossBraceRef;
    if (!crossBraceRef)
        throw new Error("Entity didn't have any cross brace. Not sure were it's gone to be honest..?");
    replaceProductPart(_entity, CROSS_BRACE, crossBraceRef, _coreServices);
};
export const attachOrDetachCrossBraceByIndex = (entities, coreServices) => {
    entities.forEach((entity, index) => {
        const isOdd = index % 2 === 1;
        if (isOdd)
            return detachCrossBrace(entity);
        if (entity.hasComponent(COMPONENT_IDS.REMOVED_CROSS_BRACE))
            attachCrossBrace(entity, coreServices);
    });
};
